import {
    createSlice
} from "@reduxjs/toolkit";
import {
    getDashboard
} from "./thunk";
export const initialState = {
    data:[],
    adminVerificationStatus: null,
    error: "", // for error message
    loading: false,
    // Cache for dashboard ads
    adsCache: {
        data: [],
        lastFetched: null
    }
};


const dashboardSlice = createSlice({
    name: "dashboard",
    initialState,
    reducers: {
        updateAdsCache: (state, action) => {
            state.adsCache.data = action.payload;
            state.adsCache.lastFetched = Date.now();
        },
        clearAdsCache: (state) => {
            state.adsCache = {
                data: [],
                lastFetched: null
            };
        }
    },
    // reducers: {
    //     apiError(state, action) {
    //         state.error = action.payload.data;
    //         state.loading = true;
    //         state.isUserLogout = false;
    //         state.errorMsg = true;
    //     },
    //     updateBusinessInfo(state, action) {
    //         if (action.payload.business_type) {
    //             state.works.business_type = action.payload.business_type
    //         }
    //         if (action.payload.gst_in) {
    //             state.works.gst_in = action.payload.gst_in
    //         }
    //         //   state.businessInfo = action.payload
    //         state.loading = false;
    //         state.errorMsg = false;
    //     },

    // },
    extraReducers: (builder) => {
        builder
            .addCase(getDashboard.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
           .addCase(getDashboard.fulfilled, (state, action) => {
            // Check if profile_verified_admin is directly inside action.payload
            state.data = action.payload; 
            console.log('verification status' , action.payload?.profile_verified_admin)
            state.adminVerificationStatus = action.payload?.profile_verified_admin; // Adjusting based on the correct structure
            
            // Cache ads data if available
            if (action.payload?.ads) {
                state.adsCache.data = action.payload.ads;
                state.adsCache.lastFetched = Date.now();
            }
            
            state.loading = false;
})
            .addCase(getDashboard.rejected, (state, action) => {
                state.error = action.payload?.error || null;
                state.loading = false;
            });
    }
});

export const {
    updateAdsCache,
    clearAdsCache
} = dashboardSlice.actions;

export default dashboardSlice.reducer;